import React from "react";
import { Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import PropertyDetails from "./pages/PropertyDetails";
import AgentList from "./pages/AgentList";
import AgentDetails from "./pages/AgentDetails";
import AboutUs from "./pages/AboutUs";
import Property from "./pages/Property";
import TermsOfUse from "./pages/TermsOfUse";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import ContactUs from "./pages/ContactUs";
import Faq from "./pages/Faq";
import AgenciesDetails from "./pages/AgenciesDetails";
import ProjectDetails from "./pages/ProjectDetails";
import NewProject from "./pages/NewProject";
import Layout from "./pages/common/Layout";
import NotFound from "./pages/NotFound";
import AgenciesList from "./pages/AgenciesList";
import News from "./pages/News";
import NewsDetails from "./pages/NewsDetails";
import DeveloperList from "./pages/DeveloperList";
import Blog from "./pages/Blog";
import TransactionsHistory from "./pages/TransactionsHistory";
import BlogDetails from "./pages/BlogDetails";

export function RoutesMain() {
    return (
        <>
            <Routes>
                <Route element={<Layout />}>
                    <Route path="/" element={<Home />} />
                    <Route path="/about-us" element={<AboutUs />} />
                    {/* <Route path="/property" element={<Property />} /> */}
                    <Route path="/property/details/:slug" element={<PropertyDetails />} />
                    <Route path="/property/:listingType/*" element={<Property />} />
                    <Route path="/agent-details/:id" element={<AgentDetails />} />
                    <Route path="/terms-of-use" element={<TermsOfUse />} />
                    <Route path="/privacy-policy" element={<PrivacyPolicy />} />
                    <Route path="/contact-us" element={<ContactUs />} />
                    <Route path="/faqs" element={<Faq />} />
                    <Route path="/agents/*" element={<AgentList />} />
                    <Route path="/find-agencies/*" element={<AgenciesList />} />
                    <Route path="/agencies/:id/*" element={<AgenciesDetails />} />
                    <Route path="/new-project/*" element={<NewProject />} />
                    <Route path="/dev-list" element={<DeveloperList />} />
                    <Route path="/dev-list/search/:name" element={<DeveloperList />} />
                    {/* <Route path="/new-projects/dev-list" element={<DeveloperList />} /> */}
                    <Route path="/news" element={<News />} />
                    <Route path="/blog" element={<Blog />} />
                    <Route path="/blog/:slug/:id" element={<BlogDetails />} />
                    <Route path="/news/:id" element={<NewsDetails />} />
                    {/* <Route path="/new-project" element={<NewProject />} /> */}
                    <Route path="/project-details/:slug" element={<ProjectDetails />} />
                    <Route path="/transactions/history" element={<TransactionsHistory />} />
                    {/* <Route path="*" element={<NotFound />} /> */}
                    <Route path="*" element={<NotFound />} />
                </Route>
            </Routes>
        </>
    );
}
